/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
    mdiBookOpenVariant,
    mdiBookOpenPageVariant,
    mdiSoccer
  } from '@mdi/js'

  export default [
      {
        label: 'Add On',
        to: '/home-module',
        icon: mdiBookOpenVariant
      },
        {
            label: 'Subject Selection',
            to: '/subject-selection',
            icon: mdiBookOpenPageVariant
        },
        {
          label: 'Interest Club Selection',
          to: '/interest-selection',
          icon: mdiSoccer
        }
]
